import { Container, Table } from "reactstrap";
import { useQuery } from "@tanstack/react-query";

import authApi from "services/auth-api";

export function CertRequestPage() {
	const query = useQuery({
		queryKey: ["certRequest"],
		queryFn: () => {
			return authApi.getCertRequest();
		},
	});

	if (!query.data && query.isLoading) {
		return <div>Loading...</div>;
	}

	const data = query?.data?.data;

	return (
		<div style={{ overflow: "auto" }}>
			<Container fluid>
				<Table bordered style={{ overflow: "hidden" }} className="shadow-lg">
					<thead style={{ backgroundColor: "#34AA80", color: "white" }}>
						<tr>
							<th>
								<p className="text-xs font-weight-bold">Order Date</p>
							</th>
							<th>
								<p className="text-xs font-weight-bold">Type of Certificate</p>
							</th>
							<th>
								<p className="text-xs font-weight-bold">Status</p>
							</th>
							<th>
								<p className="text-xs font-weight-bold">Delivery Status</p>
							</th>
							<th>
								<p className="text-xs font-weight-bold">Action</p>
							</th>
						</tr>
					</thead>
					<tbody style={{ backgroundColor: "white" }}>
						{data?.map((item) => {
							return (
								<tr key={item.id}>
									<td className="align-middle">{item.date}</td>
									<td className="align-middle">
										<p>{item.serial_no}</p>
										<p>{item.cert_name}</p>
										<ul>
											{item.courses.map((course) => {
												return (
													<li key={course.course_ID}>
														<p>{course.course_title}</p>
													</li>
												);
											})}
										</ul>
									</td>
									<td className="align-middle">{item.status}</td>
									<td className="align-middle">
										<div dangerouslySetInnerHTML={{ __html: item.delivery_info }}></div>
									</td>
									<td className="align-middle">-</td>
								</tr>
							);
						})}
					</tbody>
				</Table>
			</Container>
		</div>
	);
}
